import {SimplePropsAdder, addProps, flowMax} from 'ad-hok'
import {branchIfPassesPredicate} from 'ad-hok-utils'

import {addUserRolesQuery} from 'graphql/generated'
import {isDataLoading} from 'utils/dataLoading'

type AddUserRoles = SimplePropsAdder<{
  userIsApprover: boolean
  userIsReadOnly: boolean
}>

const addUserRoles: AddUserRoles = flowMax(
  addUserRolesQuery({}),
  branchIfPassesPredicate('me', isDataLoading),
  addProps(({me: {data: {roles}}}) => ({
    userIsApprover: roles.includes('approver'),
    userIsReadOnly: roles.includes('readonly'),
  }))
)

export default addUserRoles
